export default Object.freeze([
  { value: '0-15,000', label: '0 – 15,000' },
  { value: '15,000-50,000', label: '15,000 – 50,000' },
  { value: '50,000-100,000', label: '50,000 – 100,000' },
  { value: '100,000-250,000', label: '100,000 – 250,000' },
  { value: '250,000-500,000', label: '250,000 – 500,000' },
  { value: '500,000+', label: '500,000+' },
]);
